'use strict';

/**
 * @classname OnlyMemberText
 * @classdesc ご利用ガイドメンバー専用テキスト
 */
export default class OnlyMemberText {
	/**
	 * @constructor
	 * @param {jQuery} $e - .only member
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		if(!$('header').hasClass('header--logined')) $e.remove();
	};
};
